module.exports = __webpack_public_path__ + "img/bitdigital.da14df96.png";